import { render, staticRenderFns } from "./Inline.vue?vue&type=template&id=b4ed8700&scoped=true&"
import script from "./Inline.vue?vue&type=script&lang=js&"
export * from "./Inline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed8700",
  null
  
)

export default component.exports